// extracted by mini-css-extract-plugin
export default {"form_container":"Summary_form_container__XImVW","btn":"Summary_btn__W96Q4","prev":"Summary_prev__Tz15E","nxt":"Summary_nxt__Xn4ra"};